// Dónde sale a la red la app: backend directo o proxy same-origin.
//
// POR QUÉ EXISTE ESTE MÓDULO (21-sep-2026, item #752):
// esta decisión vivía SOLO adentro de `get-client.js`, así que la tenía axios y
// no la tenía nadie más. La telemetría (`activity-log.js`) posteaba con `fetch`
// crudo contra la URL ABSOLUTA del backend, sin enterarse de que la sesión ya
// había comprobado que esa red no lo alcanza.
//
// El resultado medido en producción: el 7 y el 8 de septiembre un médico generó
// 35 documentos —o sea la app clínica funcionaba perfecto, rerutada por el
// proxy— y su cliente no emitió UN SOLO evento de telemetría. Los otros médicos
// de esos días emitieron normal, así que no fue una caída del backend: fue que
// la telemetría no conocía el camino de atrás.
//
// La regla que queda: cuando dos piezas deciden lo mismo, la pregunta va en UNA.
// Acá.

// sessionStorage y no localStorage a propósito: el bloqueo es una propiedad de
// LA RED, no del computador. Si la médica se lleva el notebook a la casa, la
// pestaña nueva vuelve a probar el camino directo, que es el bueno.
export const CLAVE_PROXY = "smartdx:usar-proxy-same-origin";

export const proxyYaComprobado = () => {
  try {
    return sessionStorage.getItem(CLAVE_PROXY) === "1";
  } catch {
    return false; // Safari en privado tira al leer: seguimos sin memoria.
  }
};

export const recordarProxy = (valor) => {
  try {
    if (valor) sessionStorage.setItem(CLAVE_PROXY, "1");
    else sessionStorage.removeItem(CLAVE_PROXY);
  } catch {
    /* la memoria es una optimización; nunca puede romper el request */
  }
};

export const esAbsoluta = (url) => /^https?:\/\//i.test(String(url || ""));

// Resuelve la URL de un path `/api/...` respetando lo que la sesión ya sabe.
//
// Devuelve la ruta RELATIVA cuando el proxy está comprobado: la Pages Function
// de Cloudflare (`functions/api/[[path]].js`) existe solo para `/api/*`, y
// same-origin es justamente lo que el firewall del hospital no bloquea.
export const urlApi = (path) => {
  const limpio = String(path || "");
  if (proxyYaComprobado()) return limpio;
  const base = String(process.env.REACT_APP_BACKEND_URI || "").replace(/\/$/, "");
  return base ? base + limpio : limpio;
};
